'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../../../node_modules/tslib/tslib.es6.js');
var cms = require('../../../decorators/cms.js');
var enums = require('../../cms/enums.js');
var classes = require('../../cms/classes.js');

exports.StoreLocatorMapFields = class StoreLocatorMapFields extends classes.BaseComponentCMSFields {
    constructor() {
        super(...arguments);
        this.enableSearch = false;
        this.enableLocationDetailsButton = false;
        this.mapZoom = 10;
        this.latitude = 40.7831;
        this.longitude = -73.9712;
    }
};
tslib_es6.__decorate([
    cms.CMSField('Enable Search', enums.CMSFieldTypes.Toggle),
    tslib_es6.__metadata("design:type", Boolean)
], exports.StoreLocatorMapFields.prototype, "enableSearch", void 0);
tslib_es6.__decorate([
    cms.CMSField('Enable Location Details Button', enums.CMSFieldTypes.Toggle),
    tslib_es6.__metadata("design:type", Boolean)
], exports.StoreLocatorMapFields.prototype, "enableLocationDetailsButton", void 0);
tslib_es6.__decorate([
    cms.CMSField('Zoom Level', enums.CMSFieldTypes.Number),
    tslib_es6.__metadata("design:type", Number)
], exports.StoreLocatorMapFields.prototype, "mapZoom", void 0);
tslib_es6.__decorate([
    cms.CMSField('Default Latitude', enums.CMSFieldTypes.Number),
    tslib_es6.__metadata("design:type", Number)
], exports.StoreLocatorMapFields.prototype, "latitude", void 0);
tslib_es6.__decorate([
    cms.CMSField('Default Longitude', enums.CMSFieldTypes.Number),
    tslib_es6.__metadata("design:type", Number)
], exports.StoreLocatorMapFields.prototype, "longitude", void 0);
tslib_es6.__decorate([
    cms.CMSField('Marker Icon', enums.CMSFieldTypes.Image),
    tslib_es6.__metadata("design:type", String)
], exports.StoreLocatorMapFields.prototype, "markerIcon", void 0);
exports.StoreLocatorMapFields = tslib_es6.__decorate([
    cms.CMSObject('sections.maps.StoreLocator', 'Map', {
        dataRequirements: [enums.DataRequirementTypes.WebsiteLocation]
    })
], exports.StoreLocatorMapFields);
//# sourceMappingURL=maps.js.map
